import { render, staticRenderFns } from "./FieldsetContractGeneralData.yaml?vue&type=template&id=cf0dd968&component"
import script from "./FieldsetContractGeneralData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractGeneralData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports